<template>
    <div>
        <h1>Adoption Contacts</h1>
        <b-btn variant="primary" class="mb-3" @click="downloadContacts()">Download Adoption Contacts</b-btn>

        <h1 class="mt-3">Adoption Status Pages</h1>
        <div v-if="customers.length">
            <div class="row">
                <div class="col">
                    <b-pagination
                        v-model="tablePage"
                        :total-rows="filteredCustomers.length"
                        :per-page="tablePerPage"
                    ></b-pagination>
                </div>
                <div class="col">
                    <b-input-group prepend="Search">
                        <b-input type="text" v-model="searchText" @input="searchAdoptions()"></b-input>
                    </b-input-group>
                </div>
            </div>
            <b-table :items="filteredCustomers" :fields="customerFields" striped :per-page="tablePerPage" :current-page="tablePage">
                <template #cell(school)="data">
                    <router-link :to="`/adoption/view/${data.item.customer_id}?debug=1`" class="ml-3" target="_blank">{{data.item.school}}</router-link>
                </template>

                <template #cell(actions)="data">
                    <b-dropdown variant="primary">
                        <template #button-content>
                            <font-awesome-icon :icon="['fas', 'cog']" size="lg" />
                        </template>
                        <b-dropdown-item :to="`/dashboard/customerAdmin/${data.item.customer_id}`">Admin</b-dropdown-item>
                        <b-dropdown-item :to="`/adoption/view/${data.item.customer_id}?debug=1`" target="_blank">Adoption Page</b-dropdown-item>
                    </b-dropdown>
                </template>
            </b-table>

        </div>

<!--        <div v-for="(customer, i) in customers" class="row">-->
<!--            <div class="col-6">-->
<!--                Name:-->

<!--            </div>-->
<!--            <div class="col-3">-->
<!--                Customer ID:-->
<!--                <router-link :to="`/adoption/view/${customer.customer_id}?debug=1`" class="ml-3" target="_blank">{{customer.customer_id}}</router-link>-->
<!--            </div>-->
<!--            <div class="col-2">-->
<!--                Series:-->
<!--                <span class="ml-1" style="color: #3498db">-->
<!--                    {{customer.count}}-->
<!--                </span>-->
<!--            </div>-->
<!--        </div>-->
    </div>
</template>

<script>
export default {
    name: "Adoptions",
    data: () => ({
        customers: [],
        contacts: [],
        tablePerPage: 25,
        tablePage: 1,
        customerFields: [
            { key: 'school', label: 'Name', sortable: true, },
            { key: 'customer_id', label: 'Customer ID', sortable: true, },
            { key: 'company_id', label: 'Company ID', sortable: true, },
            { key: 'count', label: 'Count', sortable: true, },
            'actions'
        ],
        searchText: "",
        filteredCustomers: [],
    }),
    created() {
        this.getCustomers();
    },
    methods: {
        findContactByCompanyId(companyId) {
            return this.contacts.filter((a) => {
                return a.district_company_id == companyId || a.school_company_id == companyId;
            });
        },
        getCustomers() {
            this.axios.get('/adoption/').then((response) => {
                this.customers = response.data;
                for (let i = 0 ; i < this.customers.length; ++i) {
                    this.customers[i].contacts = this.findContactByCompanyId(this.customers[i].company_id);
                }
                this.filteredCustomers = this.customers;
            })
        },
        downloadContacts() {
            this.axios.get("/adoption/contact/csv").then((data) => {
                this.download(data.data);
                // let csvContent = "data:text/csv;charset:utf-8" + data.data;
                // let encodedUri = encodeURI(csvContent);
                // window.open(encodedUri);
            })
        },
        listContacts() {
            this.axios.get('/adoption/contact/list').then((data) => {
                console.log(data);
            })
        },
        download(data) {
            console.log(data);
            let file = new Blob([data], { type: 'text/csv' });
            let url = window.URL.createObjectURL(file)
            let a = document.createElement('a')
            a.setAttribute('href', url)
            a.setAttribute('download', 'adoption_contacts.csv');
            a.click()
        },
        searchAdoptions() {
            if (!this.searchText) {
                this.filteredCustomers = this.customers;
            }

            this.filteredCustomers = this.customers.filter(a => {
                return a.school.toLowerCase().indexOf(this.searchText.toLowerCase()) !== -1
                    || a.customer_id.toString().indexOf(this.searchText) !== -1
                    || a.company_id.toString().indexOf(this.searchText) !== -1
            });
            this.$forceUpdate();
        },
    }
}
</script>

<style scoped>

</style>